const deriveChildEmphasis = (layoutEmphasis = 'regular')=>layoutEmphasis;
const isSplitDisplay = (display)=>'splitWithImage' === display || 'withImage' === display || 'simpleSplit' === display;
const deriveEmphasisColors = (emphasis)=>({
        headingPalette: 'neutral',
        headingShade: 'bold' === emphasis ? '1' : '13',
        bodyColor: 'bold' === emphasis ? 'text-primary-3' : 'text-neutral-13'
    });
export { deriveChildEmphasis, deriveEmphasisColors, isSplitDisplay };
